import { state } from '../state.js';
import { $ } from '../utils/dom.js';
import { fmtInt } from '../utils/format.js';

export function renderMetaKPIs() {
  const rows = state.filtered.filter((row) => row.META_STATUS);
  const count = (statuses) => rows.filter((row) => statuses.includes(row.META_STATUS)).length;
  const set = (id, value) => {
    const element = $(id);
    if (element) element.textContent = fmtInt(value);
  };

  set('metaSent', count(['sent']));
  set('metaPending', count(['pending', 'processing']));
  set('metaFailed', count(['failed', 'dead_letter']));
  set('metaBlocked', count(['blocked', 'blocked_configuration']));
  set('metaMissingCtwa', rows.filter((row) => row.CTWA_PRESENT === false).length);

  const report = state.reconciliationReport;
  $('metaReconciliation').textContent = state.metaBackendConfigured
    ? `${report.reconciled} conciliadas · ${report.webhookOnly} solo webhook · ${report.unmatchedSheets} solo Sheet${report.ambiguous ? ` · ${report.ambiguous} ambiguas` : ''}`
    : 'Backend Meta sin configurar o no disponible; Google Sheets sigue activo.';
}
